import { Component, Input, OnChanges } from '@angular/core';
import { CommonService } from '../common.service';
import { SideService } from '../side.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {

  commonService;

  constructor(
    private cs: CommonService,
    public side: SideService) { this.commonService = cs; }

}
